// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NdQKKfeqJDDdX3 {\n  display: block;\n  margin-bottom: 4px;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n.NdQKKfeqJDDdX3,\n.NdQKKfeqJDDdX3:hover,\n.NdQKKfeqJDDdX3:active {\n  color: var(--ds-text, #172b4d);\n  text-decoration: none;\n}\n.NdQKKfeqJDDdX3:focus {\n  outline: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": "NdQKKfeqJDDdX3"
};
export default ___CSS_LOADER_EXPORT___;
